<template>
  <v-alert variant="flat" :icon="false" density="compact" class="registration-unavailable-alert">
    <div class="d-flex align-start ga-3">
      <v-icon class="mt-1" color="var(--fundeasy-colors-destruction-500)" size="20">
        mdi-alert-circle-outline
      </v-icon>
      <div>
        <p class="fs-16 font-weight-light-bold color-neutral-900 mb-3">
          Online registration is temporarily unavailable
        </p>
        <p class="fs-16 color-neutral-600 mb-0">
          We can't take registrations on this page right now.
        </p>
      </div>
    </div>
  </v-alert>
</template>

<style scoped>
.registration-unavailable-alert {
  background: var(--fundeasy-colors-destruction-50) !important;
  border: 1px solid var(--fundeasy-colors-destruction-200) !important;
  border-radius: 8px;
  box-shadow: none !important;
}
</style>
